import { z } from 'zod';

import {
  AvailableFunctionsSchema,
  IntegrationEnvironmentSchema,
  IntegrationMetadataSchema,
  IntegrationProviderSchema,
  ParagonConnectionIdSchema,
  ParagonUserIdSchema,
} from './integration.schema';

// COMMAND PAYLOAD SCHEMAS
export const ConnectIntegrationCommandSchema = z.object({
  provider: IntegrationProviderSchema,
  paragonConnectionId: ParagonConnectionIdSchema,
  paragonUserId: ParagonUserIdSchema,
  clientEnv: IntegrationEnvironmentSchema,
  metadata: IntegrationMetadataSchema,
});

export const EnableIntegrationCommandSchema = z.object({
  provider: IntegrationProviderSchema,
  paragonConnectionId: ParagonConnectionIdSchema,
  clientEnv: IntegrationEnvironmentSchema,
});

export const DisableIntegrationCommandSchema = z.object({
  provider: IntegrationProviderSchema,
  paragonConnectionId: ParagonConnectionIdSchema,
  clientEnv: IntegrationEnvironmentSchema,
});

export const UpdateIntegrationFunctionsCommandSchema = z.object({
  provider: IntegrationProviderSchema,
  availableFunctions: AvailableFunctionsSchema,
});

export const DisconnectIntegrationCommandSchema = z.object({
  provider: IntegrationProviderSchema,
  paragonConnectionId: ParagonConnectionIdSchema,
});

// TYPE EXPORTS
export type ConnectIntegrationCommand = z.infer<
  typeof ConnectIntegrationCommandSchema
>;
export type EnableIntegrationCommand = z.infer<
  typeof EnableIntegrationCommandSchema
>;
export type DisableIntegrationCommand = z.infer<
  typeof DisableIntegrationCommandSchema
>;
export type UpdateIntegrationFunctionsCommand = z.infer<
  typeof UpdateIntegrationFunctionsCommandSchema
>;
export type DisconnectIntegrationCommand = z.infer<
  typeof DisconnectIntegrationCommandSchema
>;
